import { render, staticRenderFns } from "./export-prioritization-modal.vue?vue&type=template&id=70245429"
import script from "./export-prioritization-modal.ts?vue&type=script&lang=ts&external"
export * from "./export-prioritization-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./export-prioritization-modal.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70245429')) {
      api.createRecord('70245429', component.options)
    } else {
      api.reload('70245429', component.options)
    }
    module.hot.accept("./export-prioritization-modal.vue?vue&type=template&id=70245429", function () {
      api.rerender('70245429', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-input/export-prioritization-modal/export-prioritization-modal.vue"
export default component.exports